<script>
import Navbar from "@/components/navbar";
import Features from "@/components/features";
import Services from "@/components/services";
import Footer from "@/components/footer";

/**
 * Main (AZTLAN LABS ) Index component
 */
export default {
  components: {
    Navbar,
    Features,
    Services,
    Footer
  }
};
</script>
<template>
  <div>
    <Navbar />

    <div v-scroll-spy>
      <!--START HOME-->
      <section
        class="section bg-home home-half"
        id="home"
        :style="{'background-image': 'url(' + require('@/assets/images/background.jpg') + ')', 'background-size': 'cover','background-position': 'center' }"
      >
        <div class="bg-overlay"></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2 text-white text-center">
              <h4 class="home-small-title"> Aztlan Labs</h4>
              <h1 class="home-title">Creamos experiencias digitales accesibles útiles y de alta calidad</h1>
              <p
                class="padding-t-15 home-desc mx-auto"
              >La mejor parte de ayudar a la transformación digital, es ver que ayudamos a las personas a llegar al siguiente nivel</p>
              <p class="play-shadow margin-l-r-auto mb-4">
                <a v-b-modal.modal class="play-btn video-play-icon">
                  <i class="mdi mdi-play text-center"></i>
                </a>
                <b-modal id="modal" hide-footer size="lg" centered header-close-variant="white">
                  <youtube video-id="RlM6A0iHIMU" ref="youtube" width="900" height="500"></youtube>
                </b-modal>
              </p>
            </div>
          </div>
        </div>
        <div class="wave-effect wave-anim">
          <div class="waves-shape shape-one">
            <div
              class="wave wave-one"
              :style="{'background-image': 'url(' + require('@/assets/images/wave-shape/wave1.png') + ')'}"
            ></div>
          </div>
          <div class="waves-shape shape-two">
            <div
              class="wave wave-two"
              :style="{'background-image': 'url(' + require('@/assets/images/wave-shape/wave2.png') + ')'}"
            ></div>
          </div>
          <div class="waves-shape shape-three">
            <div
              class="wave wave-three"
              :style="{'background-image': 'url(' + require('@/assets/images/wave-shape/wave3.png') + ')'}"
            ></div>
          </div>
        </div>
      </section>
      <!--END HOME-->
      <section class="section-sm bg-light">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="client-images my-3 my-md-0">
                <img
                  src="@/assets/images/clients/5.png"
                  alt="GCP"
                  class="mx-auto img-fluid d-block"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="client-images my-3 my-md-0">
                <img
                  src="@/assets/images/clients/6.png"
                  alt="Android Dev"
                  class="mx-auto img-fluid d-block"
                />
              </div>
            </div>

            <div class="col-md-2">
              <div class="client-images my-3 my-md-0">
                <img
                  src="@/assets/images/clients/7.png"
                  alt="iOS Dev"
                  class="mx-auto img-fluid d-block"
                />
              </div>
            </div>

          </div>
        </div>
      </section>
      <Features />
      <Services />
      <Footer />
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>